module.exports = __webpack_public_path__ + "static/img/yys.auth.55b5ddb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yys.auth.png
// module id = 1305
// module chunks = 382